import { Component, inject, OnInit } from '@angular/core'
import { Router, UrlSegment, UrlSerializer } from '@angular/router'
import { Observable } from 'rxjs'
import { map } from 'rxjs/operators'
import { NavSupportService } from '../../modules/app-menu'
import { User } from '../../models/user'
import { AuthFacadeService } from '@dot-it/jml-lib'

@Component({
  selector: 'jml-lib-not-found',
  templateUrl: './not-found.component.html',
  styleUrls: ['./not-found.component.scss']
})
export class NotFoundComponent implements OnInit {
  targetUrl$: Observable<string>
  defaultStartRoute$: Observable<string>

  navSupportService = inject(NavSupportService)
  router = inject(Router)
  serializer = inject(UrlSerializer)
  authFacadeService = inject(AuthFacadeService)

  ngOnInit(): void {
    this.targetUrl$ = this.navSupportService.desiredUrl$.pipe(
      map((routeData) => {
        console.log('not found', routeData)
        if (typeof routeData.url !== 'string') {
          const urlSegments = <UrlSegment[]>routeData.url
          const tree = this.router.createUrlTree(urlSegments, { queryParams: routeData.queryParams })
          console.log('not found tree', tree)
          const url = this.serializer.serialize(tree)
          console.log('not found url', url)
          return url
        }
        return <string>routeData.url
      })
    )

    this.defaultStartRoute$ = this.authFacadeService.defaultStartRoute$
  }

  navToStartPage(defaultStartRoute: string | undefined) {
    const startRoute = defaultStartRoute || '/dashboard'
    this.router.navigateByUrl(startRoute)
  }
}
